import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  candidateAcceptTrialOperation,
  getCandidateTrialOperations,
} from "store/actions/jobApplicationAction"
import { showAlert } from "store/reducers/alertReducer"
import NoDataAvailable from "../../../components/Shared/NoDataAvailable"

const CandidateTrialOperations = () => {
  const { loading, candidateTrialOperations } = useSelector(
    state => state.JobApplication
  )
  const { t } = useTranslation()
  document.title = t("Candidate | Yamama")
  const dispatch = useDispatch()
  const [selectedUuid, setSelectedUuid] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    getAllData()
  }, [])

  const getAllData = () => {
    dispatch(getCandidateTrialOperations())
  }

  const handleAcceptReject = () => {
    const payload = {
      uuid: selectedUuid,
    }
    dispatch(candidateAcceptTrialOperation(payload))
      .then(action => {
        const { statusCode, success, message } = action.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          setSelectedUuid(null)
          setModal(null)
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <h4 className="card-title mb-4">{t("Trial Operations")}</h4>
                <Card className="user_personal_info theme_card overflow-x-auto">
                  <CardBody>
                    <Table className="table mb-0 table-responsive">
                      <thead className="table-light full_th">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Trial Operation")}</th>
                          <th>{t("Station")}</th>
                          <th>{t("Start Date")}</th>
                          <th>{t("End Date")}</th>
                          <th>{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {candidateTrialOperations?.map((item, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.title}</td>
                            <td>{item?.station || "-"}</td>
                            <td>
                              <p className="fit_content">{item?.start_date}</p>
                            </td>
                            <td>
                              <p className="fit_content">{item?.end_date}</p>
                            </td>
                            <td>
                              <div className="d-flex gap-3 action_buttons">
                                {item?.can_cancel && (
                                  <Button
                                    color="primary"
                                    className="fit_content"
                                    onClick={() => {
                                      toggle()
                                      setSelectedUuid(item?.uuid)
                                      setSelectedItem(item)
                                    }}
                                  >
                                    {t("Accept")}
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {!loading && candidateTrialOperations?.length === 0 && (
                      <NoDataAvailable />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} size="md" backdrop="static">
        <ModalHeader toggle={toggle}>{t("Accept Trial Operation")}</ModalHeader>
        <ModalBody>
          <div className="row g-2">
            <h4>{t("Are you sure you want to confirm this date and time")}</h4>
            <h5>
              {t("Date")}: {selectedItem?.start_date} ~ {selectedItem?.end_date}
            </h5>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {t("Close")}
          </Button>
          <Button color="primary" onClick={handleAcceptReject}>
            {t("Accept")}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default CandidateTrialOperations
